/** Leyenda obligatoria (spec funcional §9.3). El tenant puede ajustar la redacción, no eliminar el contenido mínimo. */
export const LEYENDA_MINIMA =
  'Importe bruto del trato según tarja. No es un comprobante de pago. El monto a pagar lo determina la liquidación de sueldo, que incluye ingreso mínimo, semana corrida y descuentos legales.';

/** Ideas que toda redacción de la leyenda debe conservar. Cada entrada acepta variantes. */
const CONTENIDO_MINIMO: { idea: string; patrones: RegExp[] }[] = [
  { idea: 'que el importe es bruto', patrones: [/\bbruto\b/i] },
  { idea: 'que no es un comprobante de pago', patrones: [/no\s+es\s+(un\s+)?comprobante\s+de\s+pago/i] },
  { idea: 'que el monto a pagar lo determina la liquidación de sueldo', patrones: [/liquidaci[oó]n\s+de\s+sueldo/i] },
  { idea: 'el ingreso mínimo', patrones: [/ingreso\s+m[ií]nimo/i] },
  { idea: 'la semana corrida', patrones: [/semana\s+corrida/i] },
  { idea: 'los descuentos legales', patrones: [/descuentos\s+legales/i] },
];

/** Devuelve las ideas faltantes (vacío = leyenda válida). */
export function validarLeyenda(texto: string): string[] {
  return CONTENIDO_MINIMO.filter((c) => !c.patrones.some((p) => p.test(texto))).map((c) => c.idea);
}
